import { ClientConfig } from '../config/ClientConfig'
import { HttpService } from './http-service'

export type PhoneVerificationStatus = 'VERIFIED' | 'IN_PROGRESS' | 'NOT_VERIFIED';

export interface PhoneVerificationStatusResponse {
    status: PhoneVerificationStatus;
}

export const PhoneVerificationService = new class {
	async getPhoneVerificationCustomerStatus(): Promise<PhoneVerificationStatus> {
		const url = `${ClientConfig.CUSTOMER_DUE_DILIGENCE_URL}/phone-verification/status`
		try {
			const response = await HttpService.get<PhoneVerificationStatusResponse>(url, {authenticate: true})
			return response.status
		} catch {
			return 'NOT_VERIFIED'
		}
	}

	async checkPhoneVerificationCode(verificationCode: string) {
		const url = `${ClientConfig.CUSTOMER_DUE_DILIGENCE_URL}/phone-verification/check`
		await HttpService.post(url, {
			verificationCode,
		}, { authenticate: true })
	}

	async startVerification(internationalPhoneNumber: InternationalPhoneNumber) {
		const url = `${ClientConfig.CUSTOMER_DUE_DILIGENCE_URL}/phone-verification/start`
		await HttpService.post(url, {
			countryCode: internationalPhoneNumber.countryCode,
			localNumber: internationalPhoneNumber.localNumber,
		}, { authenticate: true })
	}

	directCustomerStartVerification(internationalPhoneNumber: InternationalPhoneNumber)
        : Promise<PhoneVerificationResponse> {
		const url = `${ClientConfig.CUSTOMER_DUE_DILIGENCE_URL}/customer/phone-verification/start-verification`
		return HttpService.post(url, {
			countryCode: internationalPhoneNumber.countryCode,
			localNumber: internationalPhoneNumber.localNumber,
		}, { authenticate: true })
	}

	directCustomerCheckVerification(verificationCode: string): Promise<CheckVerificationCodeResponse> {
		const url = `${ClientConfig.CUSTOMER_DUE_DILIGENCE_URL}/customer/phone-verification/check-verification`
		return HttpService.post(url, {
			verificationCode,
		}, { authenticate: true })
	}
}
